module.exports = __webpack_public_path__ + "static/img/photo10.1120a580.jpg";